import initSchemaLogger from '@wix/bi-logger-cashier-ugc';
export { BiLoggerProvider } from './BiLoggerProvider';
export { withBiLogger } from './withBiLogger';
export { BiLogger } from './types';
import { BiLogger, BiLoggerFactory } from './types';

export const createBiLogger = (biLoggerFactory: BiLoggerFactory): BiLogger => {
  return initSchemaLogger(biLoggerFactory)();
};
